import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputProcessingEventDetailsSchema } from '../schema/InputProcessingEventDetailsSchema';
import { InputProcessingEventDetailsType } from '../schema/types';
import { ProcessingEventUrl } from './ProcessingEventUrl';

const getInputProcessingEvent = (id: number) =>
  apiClient
    .get<InputProcessingEventDetailsType>(
      expand(ProcessingEventUrl.INPUT_PROCESSING_EVENT, { id })
    )
    .then((response) => InputProcessingEventDetailsSchema.parse(response.data));

export const useInputProcessingEventQuery = createApiQueryHook(
  ['inputProcessingEvent'],
  getInputProcessingEvent
);
